import { translations } from './translations';

const getValueByKeyPath = (obj, path) =>
  path.split('.').reduce((acc, part) => acc && acc[part], obj);

const buildFromNestedTranslations = () => {
  const map = {};
  const traverse = (obj, path = '') => {
    for (const [key, value] of Object.entries(obj)) {
      const currentPath = path ? `${path}.${key}` : key;
      if (typeof value === 'string') {
        const enVal = getValueByKeyPath(translations.en, currentPath);
        if (enVal && typeof enVal === 'string') {
          map[enVal.trim()] = value.trim();
        }
      } else if (typeof value === 'object' && value !== null) {
        traverse(value, currentPath);
      }
    }
  };
  traverse(translations.ar);
  return map;
};

// Page-level English strings used directly in JSX (not via t() keys)
export const pageStrings = {
  // General
  Name: 'الاسم',
  Phone: 'الهاتف',
  Email: 'البريد الإلكتروني',
  Address: 'العنوان',
  Status: 'الحالة',
  Actions: 'الإجراءات',
  Action: 'الإجراء',
  Filter: 'تصفية',
  Search: 'بحث',
  'Search...': 'البحث...',
  'Search customers...': 'البحث عن العملاء...',
  'Search orders...': 'البحث عن الطلبات...',
  'Search services...': 'البحث عن الخدمات...',
  'Search payments...': 'البحث عن المدفوعات...',
  'Search staff...': 'البحث عن الموظفين...',
  'Search by name, phone, or email...': 'البحث بالاسم أو الهاتف أو البريد...',
  Active: 'نشط',
  Inactive: 'غير نشط',
  All: 'الكل',
  'All Status': 'كل الحالات',
  Save: 'حفظ',
  Cancel: 'إلغاء',
  Edit: 'تعديل',
  Delete: 'حذف',
  Close: 'إغلاق',
  Submit: 'إرسال',
  Reset: 'إعادة تعيين',
  Yes: 'نعم',
  No: 'لا',
  Description: 'الوصف',
  Price: 'السعر',
  Category: 'الفئة',
  Duration: 'المدة',
  VIP: 'كبار الشخصيات',
  Regular: 'عادي',
  Corporate: 'شركات',
  Cash: 'نقداً',
  Card: 'بطاقة',
  Online: 'عبر الإنترنت',
  Received: 'تم الاستلام',
  Washing: 'جاري الغسيل',
  Drying: 'جاري التجفيف',
  Ready: 'جاهز',
  Delivered: 'تم التسليم',
  Paid: 'مدفوع',
  Unpaid: 'غير مدفوع',
  Pending: 'معلق',
  Failed: 'فشل',
  Refunded: 'مسترجع',
  Pickup: 'استلام',
  Delivery: 'توصيل',
  View: 'عرض',
  'View Details': 'عرض التفاصيل',
  New: 'جديد',
  'N/A': 'غير متوفر',

  // Customers
  'Customer Management': 'إدارة العملاء',
  'All Customers': 'كل العملاء',
  'Manage all customer records and their activity.': 'إدارة سجلات العملاء ونشاطهم.',
  'Add Customer': 'إضافة عميل',
  'Add New Customer': 'إضافة عميل جديد',
  'Edit Customer': 'تعديل بيانات العميل',
  'Save Customer': 'حفظ العميل',
  'Save / Update': 'حفظ / تحديث',
  'Cancel / Exit': 'إلغاء / خروج',
  'Delete Customer': 'حذف العميل',
  'Customer Profile': 'ملف العميل',
  'Customer Details': 'تفاصيل العميل',
  'Customer Identity': 'هوية العميل',
  'Customer ID': 'رقم العميل',
  'Customer Level': 'مستوى العميل',
  'Customer Level Dropdown': 'مستوى العميل',
  'Customer Level *': 'مستوى العميل *',
  'Customer Level:': 'مستوى العميل:',
  'Customer No': 'رقم العميل',
  'Arabic Name': 'الاسم بالعربية',
  'English Name': 'الاسم بالإنجليزية',
  'English Name *': 'الاسم بالإنجليزية *',
  'Part No': 'رقم القطعة',
  'Area Name': 'اسم المنطقة',
  Jadda: 'جادة',
  Street: 'الشارع',
  'Level No': 'رقم الطابق',
  'House No': 'رقم المنزل',
  'Flat No': 'رقم الشقة',
  'Address Notes': 'ملاحظات العنوان',
  'Auto Address No': 'رقم العنوان التلقائي',
  'Automatic Address No': 'رقم العنوان التلقائي',
  'Insurance Paid': 'التأمين المدفوع',
  'Insurance Amount': 'مبلغ التأمين',
  'Invoices Count': 'عدد الفواتير',
  'Last Invoice Date': 'تاريخ آخر فاتورة',
  'Free Balance': 'رصيد مجاني',
  'Free Total': 'إجمالي مجاني',
  'General Notes': 'ملاحظات عامة',
  'Total Orders': 'إجمالي الطلبات',
  'Registration Date': 'تاريخ التسجيل',
  Balance: 'الرصيد',
  Notes: 'ملاحظات',
  'Select Area': 'اختر المنطقة',
  'Select Level': 'اختر المستوى',
  'Customers List': 'قائمة العملاء',
  'Export to CSV': 'تصدير إلى CSV',
  'Export to JSON': 'تصدير إلى JSON',
  'Phone Numbers': 'أرقام الهاتف',
  'Primary Phone No.': 'رقم الهاتف الأساسي',
  'Phone No. *': 'رقم الهاتف *',
  'Alternate No. 1': 'رقم بديل 1',
  'Alternate No. 2': 'رقم بديل 2',
  'Alternate No. 3': 'رقم بديل 3',
  'Address & Location': 'العنوان والموقع',
  'Paci No.': 'رقم باسي',
  'Billing & Financial Details': 'تفاصيل الفواتير والمالية',
  'Operational Stats': 'إحصائيات التشغيل',
  'Outstanding Balance': 'الرصيد المستحق',
  'Total Spent': 'إجمالي الإنفاق',
  'Avg. Order Value': 'متوسط قيمة الطلب',
  Discount: 'الخصم',
  'Discount Value (%)': 'قيمة الخصم (%)',
  'Auto-generated': 'يُنشأ تلقائياً',
  'Are you sure you want to delete': 'هل أنت متأكد أنك تريد حذف',
  'This action cannot be undone.': 'لا يمكن التراجع عن هذا الإجراء.',
  'Confirm Delete': 'تأكيد الحذف',
  customers: 'عملاء',

  // Orders
  'Add Order': 'إضافة طلب',
  'New Order': 'طلب جديد',
  'Create Order': 'إنشاء طلب',
  'Order List': 'قائمة الطلبات',
  'Order Tracking': 'تتبع الطلب',
  'All Orders': 'كل الطلبات',
  'Add New Order': 'إضافة طلب جديد',
  'Order #': 'رقم الطلب',
  Customer: 'العميل',
  Service: 'الخدمة',
  Amount: 'المبلغ',
  Date: 'التاريخ',
  Payment: 'الدفع',
  'Payment Method': 'طريقة الدفع',
  'Order Date': 'تاريخ الطلب',
  'Order Status': 'حالة الطلب',
  'Add Service': 'إضافة خدمة',
  'Service Name': 'اسم الخدمة',
  'Base Price': 'السعر الأساسي',
  'Add New Service': 'إضافة خدمة جديدة',
  'Edit Service': 'تعديل الخدمة',
  'Delete Service': 'حذف الخدمة',
  'Service Details': 'تفاصيل الخدمة',

  // Staff
  'Staff Management': 'إدارة الموظفين',
  'Staff Members': 'أعضاء الموظفين',
  'Add Staff Member': 'إضافة عضو موظف',
  'Add Staff': 'إضافة موظف',
  'Edit Staff': 'تعديل الموظف',
  'Roles & Permissions': 'الأدوار والصلاحيات',
  'Active Status': 'الحالة النشطة',
  'Full Name': 'الاسم الكامل',
  Password: 'كلمة المرور',
  'Confirm Password': 'تأكيد كلمة المرور',
  Permissions: 'الصلاحيات',
  Rider: 'مندوب',
  Counter: 'موظف استقبال',
  Admin: 'مدير عمليات',
  'Select Rider': 'اختر المندوب',
  'Assign Rider': 'تعيين المندوب',
  'Assigned Rider': 'مندوب التوصيل',
  'Pickup Date': 'تاريخ الاستلام',
  'Delivery Date': 'تاريخ التوصيل',

  // Settings
  'Business Profile': 'الملف التجاري',
  'System Settings': 'إعدادات النظام',
  'Theme Settings': 'إعدادات المظهر',
  'Notification Settings': 'إعدادات الإشعارات',
  'Security Settings': 'الإعدادات الأمنية',
  'Account Settings': 'إعدادات الحساب',
  'VAT Number': 'الرقم الضريبي',
  Currency: 'العملة',
  Language: 'اللغة',
  'Save Settings': 'حفظ الإعدادات',
  'Change Password': 'تغيير كلمة المرور',
  'Current Password': 'كلمة المرور الحالية',
  'New Password': 'كلمة المرور الجديدة',
  'Save Profile': 'حفظ الملف الشخصي',
  'General Settings': 'الإعدادات العامة',
  'System Configuration': 'تكوين النظام',
  'Business Information': 'معلومات العمل',
  'Store Address': 'عنوان المتجر',
  'Contact Number': 'رقم الاتصال',
  'Tax Rate (%)': 'نسبة الضريبة (%)',
  'Profile Settings': 'إعدادات الملف الشخصي',

  // Reports
  Reports: 'التقارير',
  'Daily Revenue': 'الإيرادات اليومية',
  'Orders Trend': 'اتجاه الطلبات',
  'Service Revenue': 'إيرادات الخدمات',
  'Last 7 days': 'آخر 7 أيام',
  'Weekly volume': 'الحجم الأسبوعي',
  'By category': 'حسب الفئة',
  'Year to date': 'منذ بداية العام',
  'Monthly Revenue': 'الإيرادات الشهرية',
  'Actions Log': 'سجل العمليات',
  'Recent Orders': 'أحدث الطلبات',
  'Services List': 'قائمة الخدمات',

  // Sidebar & Navbar
  Branches: 'الفروع',
  'Make Invoices': 'إنشاء فاتورة',
  'All Branches': 'جميع الفروع',
  'Select Branch': 'اختر الفرع',
  'Live Update:': 'تحديث مباشر:',
  'Live Update': 'تحديث مباشر',
  Express: 'مستعجل',
  PRO: 'برو',
  'Focus Mode': 'وضع التركيز',
  'Welcome back, Operations Lead': 'مرحباً بك مجدداً، مدير العمليات',
  'Track laundry volume, dispatch readiness, and revenue performance in a clean and modern interface.':
    'تتبع حجم الغسيل، وجاهزية الإرسال، وأداء الإيرادات في واجهة مستخدم نظيفة وحديثة.',
  'Orders Today': 'طلبات اليوم',
  'Revenue This Month': 'إيرادات هذا الشهر',
  'Ready Orders': 'الطلبات الجاهزة',
  'Delivered Orders': 'الطلبات المسلمة',
  'Activity timeline': 'مخطط النشاط',
  'Operations feed': 'تغذية العمليات',
  Live: 'مباشر',
  'Quick actions': 'إجراءات سريعة',
  'Speed up workflow': 'تسريع سير العمل',
  'Schedule Pickup': 'جدولة استلام',
  'Collect Payments': 'تحصيل المدفوعات',
  'Create Order Hint': 'إضافة خدمة',
  'Schedule Pickup Hint': 'إرسال السائق',
  'Collect Payments Hint': 'معالجة الفاتورة',
  'System Settings Hint': 'تكوين الإعدادات',
  'Last 5 orders from the Orders list.': 'آخر 5 طلبات من قائمة الطلبات.',
  'View all orders': 'عرض كل الطلبات',
  'Monthly Revenue Chart': 'مخطط الإيرادات الشهرية',
  'Daily Revenue Graph': 'رسم بياني للإيرادات اليومية',
  'Service-Wise Revenue': 'إيرادات كل خدمة',
  'LCD Display': 'شاشة العرض',
  'Toggle menu': 'تبديل القائمة',
  'Close menu': 'إغلاق القائمة',

  // Branches
  'Manage your laundry branch locations': 'إدارة فروع المغسلة',
  'Add Branch': 'إضافة فرع',
  'Search branches...': 'البحث عن الفروع...',
  'Branch Name': 'اسم الفرع',
  Manager: 'المدير',
  Contact: 'الرقم',
  'No branches found.': 'لم يتم العثور على فروع.',
  'Branch Name *': 'اسم الفرع *',
  'Phone Number *': 'رقم الهاتف *',
  'Full Address *': 'العنوان الكامل *',
  'Email Address': 'البريد الإلكتروني',
  'Branch Manager': 'مدير الفرع',
  'Select a Manager...': 'اختر مديراً...',
  'Save Branch': 'حفظ الفرع',
  'Add New Branch': 'إضافة فرع جديد',
  'Register a new branch location': 'تسجيل موقع فرع جديد',
  'Are you sure you want to delete this branch?': 'هل أنت متأكد أنك تريد حذف هذا الفرع؟',
  'Branch deleted successfully': 'تم حذف الفرع بنجاح',
  'Please fill in all required fields': 'يرجى تعبئة جميع الحقول المطلوبة',
  'Branch added successfully!': 'تم إضافة الفرع بنجاح!',
  'Edit Branch': 'تعديل الفرع',
  'Update branch location details': 'تحديث تفاصيل موقع الفرع',
  'Branch updated successfully!': 'تم تحديث الفرع بنجاح!',

  // Branch names
  'Branch Name (Arabic)': 'اسم الفرع (بالعربية)',
  'Branch Name (English)': 'اسم الفرع (بالإنجليزية)',
  'Home Service': 'خدمة المنازل',
  'Home service': 'خدمة المنازل',
  workshop: 'الورشة',
  Workshop: 'الورشة',
  'Carpet section': 'قسم السجاد',
  'carpet section': 'قسم السجاد',
  'shoe section': 'قسم الأحذية',
  'Shoe section': 'قسم الأحذية',
  Ragheey: 'الرقعي',
  Mishrif: 'مشرف',
  Andalus: 'الأندلس',
  Ardiya: 'العارضية',
  Khaitan: 'خيطان',
  Qurain: 'القرين',
  Quirain: 'القرين',
  Jahra: 'الجهراء',
  Rigai: 'الرقعي',
  'Ragheey Area': 'منطقة الرقعي',
  'Mishrif Area': 'منطقة مشرف',
  'Andalus Area': 'منطقة الأندلس',
  'Ardiya Area': 'منطقة العارضية',
  'Khaitan Area': 'منطقة خيطان',
  'Qurain Area': 'منطقة القرين',
  'Jahra Area': 'منطقة الجهراء',
  'Rigai Area': 'منطقة الرقعي',
  'Manager 1': 'مدير 1',
  'Manager 2': 'مدير 2',
  'Manager 3': 'مدير 3',
  'Manager 4': 'مدير 4',
  'Manager 5': 'مدير 5',
  'Manager 6': 'مدير 6',
  'Manager 7': 'مدير 7',
  'Manager 8': 'مدير 8',

  // Order statuses
  Waiting: 'قيد الانتظار',
  'Preparing in shop': 'قيد التحضير في المحل',
  'Preparing in workshop': 'قيد التحضير في الورشة',
  Hold: 'معلق',
  'Ready for delivery': 'جاهز للتوصيل',
  'Ready for shop': 'جاهز للمحل',
  'In Workshop': 'في الورشة',
  'In Shop': 'في المحل',
  'H Services': 'خدمة منزلية',
  'With Driver': 'مع السائق',
  'On Hold': 'معلق',
  Return: 'مرتجع',
  Store: 'في المخزن',
  'In Store': 'في المخزن',
  Partial: 'جزئي',
  Assigned: 'مسند',
  'In Progress': 'قيد التنفيذ',
  'Picked Up': 'تم الاستلام',
  Completed: 'مكتمل',
  'Out For Delivery': 'خارج للتوصيل',

  // Services
  'Wash & Fold': 'غسيل وطي',
  'Wash & Iron': 'غسيل وكوي',
  'Dry Cleaning': 'تنظيف جاف',
  'Blanket Cleaning': 'تنظيف بطانيات',
  'Premium Care': 'عناية فائقة',
  Ironing: 'كوي',
  'Express Wash': 'غسيل مستعجل',
  Normal: 'عادي',
  Urgent: 'مستعجل',
  'Dry Clean': 'تنظيف جاف',
  'Iron Only': 'كوي فقط',
  'Wash & Iron Only': 'غسيل وكوي فقط',

  // Login
  'Sign In': 'تسجيل الدخول',
  'Sign in to your account': 'سجّل الدخول إلى حسابك',
  Username: 'اسم المستخدم',
  'Remember me': 'تذكرني',
  'Forgot password?': 'نسيت كلمة المرور؟',
  'Contact Administrator': 'الاتصال بالمسؤول',
  'This is a secure enterprise portal. Please contact your Branch Manager or Super Admin to reset your password.': 'هذه بوابة مؤسسة آمنة. يرجى الاتصال بمدير الفرع أو المسؤول المتميز لإعادة تعيين كلمة المرور الخاصة بك.',
  'Okay, Understood': 'حسناً، مفهوم',
  'Invalid credentials': 'بيانات الدخول غير صحيحة',

  // Services
  'Service Management': 'إدارة الخدمات',
  'Laundry Services': 'خدمات الغسيل',
  'Manage service categories and pricing.': 'إدارة فئات الخدمات والأسعار.',
  'Est. Time': 'الوقت المقدر',
  ID: 'المعرف',
  'All Categories': 'كل الفئات',
  'Estimated Time': 'الوقت المقدر',
  '24 hours': '24 ساعة',
  '48 hours': '48 ساعة',
  '72 hours': '72 ساعة',
  'Service added successfully': 'تمت إضافة الخدمة بنجاح',
  'Service updated successfully': 'تم تحديث الخدمة بنجاح',

  // Payments
  'Payment Management': 'إدارة المدفوعات',
  'All Payments': 'كل المدفوعات',
  'Add Payment': 'إضافة دفعة',
  'Transaction ID': 'رقم المعاملة',
  'Total Amount': 'المبلغ الإجمالي',

  // Staff pages
  'Add New Staff': 'إضافة موظف جديد',
  'Back to Staff': 'العودة إلى الموظفين',
  'Staff Details': 'تفاصيل الموظف',
  'Assigned Branch': 'الفرع المعين',
  'Counter Staff': 'موظف الاستقبال',
  'Delivery Staff': 'موظف التوصيل',
  'Operations Lead': 'مدير العمليات',

  // Drivers
  'Driver Management': 'إدارة السائقين',
  'Add Driver': 'إضافة سائق',
  'All Drivers': 'كل السائقين',

  // Invoices
  'Invoice Management': 'إدارة الفواتير',
  'All Invoices': 'كل الفواتير',
  'Invoice No': 'رقم الفاتورة',
  'Invoice No.': 'رقم الفاتورة',
  'Invoice Date': 'تاريخ الفاتورة',
  'Due Date': 'تاريخ الاستحقاق',

  // Pickup/Delivery
  'Pickup & Delivery': 'الاستلام والتوصيل',
  'Schedule Pickup/Delivery': 'جدولة الاستلام/التوصيل',

  // General confirmations
  'No data found': 'لا توجد بيانات',
  'No results found': 'لم يتم العثور على نتائج',
  Total: 'الإجمالي',
  'Back': 'رجوع',
  'Next': 'التالي',
  'Previous': 'السابق',
  'Loading...': 'جاري التحميل...',
  'Required': 'مطلوب',
  'Optional': 'اختياري',
  'Update': 'تحديث',
  'Create': 'إنشاء',
  'Confirm': 'تأكيد',
  'Details': 'التفاصيل',
  'Overview': 'نظرة عامة',
  'Print': 'طباعة',
  'Download': 'تحميل',
  'Export': 'تصدير',
  'Stain Removal': 'إزالة البقع',
  'Wool Care': 'عناية الصوف',
  'Silk Handling': 'عناية الحرير',
  'Leather Cleaning': 'تنظيف الجلد',
  'Uniform Cleaning': 'تنظيف الزي الرسمي',
  'Suit Pressing': 'كوي البدلة',
  'Bulk Wash': 'غسيل بالجملة',
  '7 days': '7 أيام',
  '12 hours': '12 ساعة',
  '36 hours': '36 ساعة',
  '6 hours': '6 ساعات',
};

export const getFlatTranslationMap = () => ({
  ...buildFromNestedTranslations(),
  ...pageStrings,
});

export const translateString = (text, lang) => {
  if (!text || lang !== 'ar') return text;
  const map = getFlatTranslationMap();
  const trimmed = String(text).trim();
  return map[trimmed] || text;
};
